import { I18n } from '@calendly/i18n'
import { ParagraphIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { colorIconSecondary, colorTextSecondary } from '@calendly/ui/theme'

import { useEventType } from 'features/event_type_provider'

import { TrimmedSubheader } from '../../components/styles'

const placeholderText = (isLocked) => (isLocked
  ? I18n.t('publisher.event_type_editor.sections.more_options.description.missing')
  : I18n.t('publisher.event_type_editor.sections.more_options.description.helper_text'))

export const Summary = ({ isLocked }) => {
  const { description } = useEventType()
  const textDescription = description?.replace(/<[^>]*>/g, ' ')

  return (
    <BodyText color={colorTextSecondary} size="medium">
      <ParagraphIcon size="standard" color={colorIconSecondary} spacingRight="8" />
      <TrimmedSubheader>{textDescription || placeholderText(isLocked)}</TrimmedSubheader>
    </BodyText>
  )
}
